import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { resetComparison } from "../actions";

class Dialog extends Component {
    constructor(props) {
        super(props);
        this.parameters = {
            title: "",
            msg: "",
        };
        this.closeModal = this.closeModal.bind(this);
    }

    closeModal() {
        this.props.resetComparison();
    }

    shouldComponentUpdate(props) {
        if (props.comparison.result) {
            this.parameters = {
                title: {
                    label: "BRAVO !",
                    color: "panel panel-success text-center",
                },
                msg: {
                    label:
                        "Tu as réussi, la reproduction est identique au modèle.",
                    color: "text-success",
                },
            };
        } else {
            this.parameters = {
                title: {
                    label: "Vérifie ton travail !",
                    color: "panel panel-danger text-center",
                },
                msg: {
                    label: `La reproduction (figure et/ou disposition sur le quadrillage) n'est pas identique au modèle !`,
                    color: "text-warning",
                },
            };
        }
        return true;
    }
    render() {
        const { title, msg } = this.parameters;
        const { comparison } = this.props;
        const visible = comparison.isOpen ? "modal fade in" : "modal fade";
        const style = comparison.isOpen
            ? { display: "block", paddingRight: "15px" }
            : {};

        return (
            <div
                className={visible}
                tabIndex="-1"
                role="dialog"
                style={style}
                aria-labelledby="mySmallModalLabel"
            >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className={title.color}>
                            <div className="panel-heading">
                                <h3>{title.label}</h3>
                            </div>
                            <div className="panel-body">
                                <p className={msg.color}>{msg.label}</p>
                            </div>
                            <div className="panel-footer">
                                <button
                                    className="btn btn-default"
                                    onClick={this.closeModal}
                                >
                                    Fermer
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ comparison }) => {
    return { comparison };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({ resetComparison }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(Dialog);
